import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AutenticaoService } from 'src/app/auth/autenticacao.service';
import { environment } from 'src/environments/environment';
import { HistoricoSolicitacao } from './../../models/historicoSolicitacoes/historico-solicitacao.model';
import { HistoricoSolicitacoesService } from './historico-solicitacoes.service';

@Component({
  selector: 'app-historico-solicitacoes',
  templateUrl: './historico-solicitacoes.component.html',
  styleUrls: ['./historico-solicitacoes.component.scss']
})
export class HistoricoSolicitacoesComponent implements OnInit {
  public ativo = true;
  itemDeclaracao: boolean;
  itemOfertas: boolean;
  historicoSolicitacao = new HistoricoSolicitacao;
  public executar = false;


  constructor(private cookieService: CookieService,
    private historicoSolicitacoesService: HistoricoSolicitacoesService,
    private autenticaoService: AutenticaoService) {
    this.ativo = true;
    this.itemDeclaracao = true;
    this.checarAcessoViaRedirect();
  }

  async checarAcessoViaRedirect(){
    sessionStorage.setItem('pathRedirect','/historico-solicitacoes');
    if(sessionStorage.getItem("accessTokenJWT") == null){
      if(!this.cookieService.get('Valgrind-AU')){
        window.location.href= environment.urlPortal + "/entrar?redirectUrl=" + environment.urlRedirecionamentoHistSolicitacoes;
      }
     this.autenticaoService.accessTokenExiste.subscribe(res =>{
       if(res){
         this.executar = res;
       }
     });
    }else{
     this.executar = true;
    }
  }

  ngOnInit(): void {
    this.itemDeclaracao = true;
     this.checarAcessoViaRedirect();

    if(this.executar) {
      this.consultaHistorico();
    }
  }

  consultaHistorico() {


    this.historicoSolicitacoesService.consultaHistorico().subscribe(resposta => {
      this.historicoSolicitacao = resposta;
    }, err => {
      console.log(err, 'Erro consulta histórico');
      this.ativo = false;
    }).add(() =>{
      setTimeout(() => {
        this.ativo = false;
      }, 1000);
    })

  }

  menuAtivo(menu: string) {
    switch (menu) {
      case 'declaracao':
        this.itemDeclaracao = true;
        this.itemOfertas = false;
        break;
      case 'ofertas':
        this.itemOfertas = true;
        this.itemDeclaracao = false;
        break;
    }
  }
}
